var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"teacher-introduced"},[_c(_vm.componentName,{tag:"compunent",on:{"teacher-list":_vm.teacherList,"teacher-item":_vm.teacherItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }